import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { BsSearch } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import {
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { getTecnicosKae, getAaffsKae } from "../../services";
import {
  cambiarFormatoNombre,
  municipiosIniciales,
} from "../../functions/funciones";
import {
  ordenarNombreYApellido,
  ordenarProvinciasYMunicipios,
} from "../../functions/ordenarListas";
import { UsuarioContext } from "../../providers/userContext";
import SearchProgresState from "./SearchProgresState";

const ESTADOS_KAE_FILTRO = [
  { id: 1, key: "Activa" },
  { id: 4, key: "Baja" },
  { id: 5, key: "Anulado" },
];

const FiltrosInstalaciones = ({ onFilter, clearFilter, filtrosIniciales }) => {
  const { t } = useTranslation("common");
  const user = useContext(UsuarioContext);
  const showAaffFilter = user?.rol === "ADMIN" || user?.rol === "VENT" || user?.rol === "COMM" || user?.rol === "TECH" || user?.rol === "TECH_COOR";
  const showEstadoFilter = user?.rol === "ADMIN" || user?.rol === "VENT";
  const [busqueda, setBusqueda] = useState(filtrosIniciales || {});
  const [tecnicos, setTecnicos] = useState([]);
  const [aaffs, setAaffs] = useState([]);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, busqueda.provincia)
    );
  }, [busqueda.provincia]);

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    if (e.target.name === "provincia" || e.target.value === "") {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
        municipio: "",
      });
    } else {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
      });
    }
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const esSafari = () => {
    const ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua);
  };

  const [typeFacturaInicio, setTypeFacturaInicio] = useState(esSafari() ? "date" : "text");
  const [typeFacturaFin, setTypeFacturaFin] = useState(esSafari() ? "date" : "text");
  const [typeFactura2Inicio, setTypeFactura2Inicio] = useState(esSafari() ? "date" : "text");
  const [typeFactura2Fin, setTypeFactura2Fin] = useState(esSafari() ? "date" : "text");
  const [typeRealizadaInicio, setTypeRealizadaInicio] = useState(esSafari() ? "date" : "text");
  const [typeRealizadaFin, setTypeRealizadaFin] = useState(esSafari() ? "date" : "text");

  useEffect(() => {
    cargarTecnicos();
  }, []);

  useEffect(() => {
    if (showAaffFilter && busqueda?.aaff_id && !aaffs.find((a) => a.id === busqueda.aaff_id)) {
      cargarAaffs();
    }
  }, [busqueda?.aaff_id, showAaffFilter]);

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      localStorage.setItem("hasReloaded", "false");
    }
  }, [location]);

  const cargarTecnicos = async () => {
    try {
      const res = await getTecnicosKae();
      const list = Array.isArray(res) ? res : res?.data || [];
      setTecnicos(ordenarNombreYApellido(list));
    } catch (err) {
      console.log(err);
    }
  };

  const cargarAaffs = async (razonSocial) => {
    try {
      const res = await getAaffsKae(razonSocial);
      const list = Array.isArray(res) ? res : res?.data || [];
      setAaffs(list);
    } catch (err) {
      console.log(err);
    }
  };

  const busquedaInputAaff = (name, valorBusqueda) => {
    if (name === "aaff_id") {
      cargarAaffs(valorBusqueda || undefined);
    }
  };

  const clearAllFilters = () => {
    setBusqueda({});
    if (typeof clearFilter === "function") clearFilter();
  };

  const handleChange = (evt) => {
    setBusqueda({ ...busqueda, [evt.target.name]: evt.target.value });
  };

  const handleBooleanChange = (evt) => {
    const value = evt.target.value;
    const boolValue = value === "" ? undefined : value === "true";
    setBusqueda({ ...busqueda, [evt.target.name]: boolValue });
  };

  const getBusqueda = () => {
    const cleaned = { ...busqueda };
    for (const key in cleaned) {
      if (typeof cleaned[key] === "boolean") continue;
      if (cleaned[key] === "" || cleaned[key] === null || cleaned[key] === undefined) {
        delete cleaned[key];
      }
    }
    onFilter(cleaned);
  };

  const handleFocusFacturaInicio = () => !esSafari() && setTypeFacturaInicio("date");
  const handleBlurFacturaInicio = () => {
    if (!esSafari() && !busqueda.fechaFacturaInicio) setTypeFacturaInicio("text");
  };
  const handleFocusFacturaFin = () => !esSafari() && setTypeFacturaFin("date");
  const handleBlurFacturaFin = () => {
    if (!esSafari() && !busqueda.fechaFacturaFin) setTypeFacturaFin("text");
  };
  const handleFocusFactura2Inicio = () => !esSafari() && setTypeFactura2Inicio("date");
  const handleBlurFactura2Inicio = () => {
    if (!esSafari() && !busqueda.fechaFactura2Inicio) setTypeFactura2Inicio("text");
  };
  const handleFocusFactura2Fin = () => !esSafari() && setTypeFactura2Fin("date");
  const handleBlurFactura2Fin = () => {
    if (!esSafari() && !busqueda.fechaFactura2Fin) setTypeFactura2Fin("text");
  };
  const handleFocusRealizadaInicio = () => !esSafari() && setTypeRealizadaInicio("date");
  const handleBlurRealizadaInicio = () => {
    if (!esSafari() && !busqueda.fechaRealizadaInicio) setTypeRealizadaInicio("text");
  };
  const handleFocusRealizadaFin = () => !esSafari() && setTypeRealizadaFin("date");
  const handleBlurRealizadaFin = () => {
    if (!esSafari() && !busqueda.fechaRealizadaFin) setTypeRealizadaFin("text");
  };

  return (
    <>
      <div className="buscadorFiltros">
        <div style={{ width: "100%" }}>
          <Box mx={1} display={"block"} flexDirection={"row"} gap={2}>
            <TextField
              id="nif-input"
              label={t("filters.nif")}
              variant="outlined"
              name="nif"
              className="filtros altura"
              value={busqueda.nif || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
            />
            <TextField
              id="comunidad-input"
              label={t("filters.community")}
              variant="outlined"
              name="comunidad"
              className="filtros altura"
              value={busqueda.comunidad || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
            />
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="provincia-label">{t("filters.province")}</InputLabel>
              <Select
                labelId="provincia-label"
                id="province-select"
                label={t("filters.province")}
                name="provincia"
                className="filtros"
                value={busqueda.provincia || ""}
                onChange={seleccionarMunicipios}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => (
                  <MenuItem key={i} value={e.name}>
                    {e.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="municipio-label">{t("filters.municipality")}</InputLabel>
              <Select
                labelId="municipio-label"
                id="municipio-select"
                label={t("filters.municipality")}
                name="municipio"
                className="filtros"
                value={busqueda?.municipio || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {listadoMunicipios
                  .sort(ordenarProvinciasYMunicipios)
                  ?.map((e, i) => (
                    <MenuItem key={i} value={e.name}>
                      {e.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {showAaffFilter && (
              <FormControl variant="outlined" className="filtros-select">
                <SearchProgresState
                  labelId="aaff-label"
                  id="aaff-select"
                  label={t("filters.aaff")}
                  name="aaff_id"
                  className="filtros altura"
                  tipo="razonSocial"
                  array={aaffs}
                  busquedaInput={busquedaInputAaff}
                  onOptionSelected={(name, value) =>
                    setBusqueda({ ...busqueda, [name]: value?.id })
                  }
                  valueOnLoad={
                    aaffs.find((a) => a.id === busqueda?.aaff_id) || null
                  }
                />
              </FormControl>
            )}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="tecnico-label">{t("filters.technician")}</InputLabel>
              <Select
                labelId="tecnico-label"
                id="tecnico-select"
                label={t("filters.technician")}
                name="tech_id"
                className="filtros"
                value={busqueda?.tech_id || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {tecnicos.map((tec) => (
                  <MenuItem key={tec.id} value={tec.id}>
                    {`${tec.nombre || ""} ${tec.apellidos || ""}`.trim()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="realizada-label">{t("filters.performed")}</InputLabel>
              <Select
                labelId="realizada-label"
                id="realizada-select"
                label={t("filters.performed")}
                name="realizada"
                className="filtros"
                value={busqueda?.realizada !== undefined ? String(busqueda.realizada) : ""}
                onChange={handleBooleanChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                <MenuItem value="true">{t("filters.yes")}</MenuItem>
                <MenuItem value="false">{t("filters.no")}</MenuItem>
              </Select>
            </FormControl>
            {showEstadoFilter && (
              <FormControl variant="outlined" className="filtros-select">
                <InputLabel id="estado-label">{t("filters.state", { defaultValue: "Estado" })}</InputLabel>
                <Select
                  labelId="estado-label"
                  id="estado-select"
                  label={t("filters.state", { defaultValue: "Estado" })}
                  name="estado_id"
                  className="filtros"
                  value={busqueda?.estado_id || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                >
                  <MenuItem value="" style={{ height: 40 }}></MenuItem>
                  {ESTADOS_KAE_FILTRO.map((est) => (
                    <MenuItem key={est.id} value={est.id}>
                      {t(`stateNames.${est.key}`, { defaultValue: est.key })}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <TextField
              type={typeFacturaInicio}
              id="fechaFacturaInicio-input"
              label={t("filters.invoiceDateFrom")}
              variant="outlined"
              name="fechaFacturaInicio"
              className="filtros altura"
              value={busqueda.fechaFacturaInicio || ""}
              onChange={handleChange}
              onFocus={handleFocusFacturaInicio}
              onBlur={handleBlurFacturaInicio}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
            <TextField
              type={typeFacturaFin}
              id="fechaFacturaFin-input"
              label={t("filters.invoiceDateTo")}
              variant="outlined"
              name="fechaFacturaFin"
              className="filtros altura"
              value={busqueda.fechaFacturaFin || ""}
              onChange={handleChange}
              onFocus={handleFocusFacturaFin}
              onBlur={handleBlurFacturaFin}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
            <TextField
              type={typeFactura2Inicio}
              id="fechaFactura2Inicio-input"
              label={t("filters.invoiceDate2From")}
              variant="outlined"
              name="fechaFactura2Inicio"
              className="filtros altura"
              value={busqueda.fechaFactura2Inicio || ""}
              onChange={handleChange}
              onFocus={handleFocusFactura2Inicio}
              onBlur={handleBlurFactura2Inicio}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
            <TextField
              type={typeFactura2Fin}
              id="fechaFactura2Fin-input"
              label={t("filters.invoiceDate2To")}
              variant="outlined"
              name="fechaFactura2Fin"
              className="filtros altura"
              value={busqueda.fechaFactura2Fin || ""}
              onChange={handleChange}
              onFocus={handleFocusFactura2Fin}
              onBlur={handleBlurFactura2Fin}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
            <TextField
              type={typeRealizadaInicio}
              id="fechaRealizadaInicio-input"
              label={t("filters.realizationDateFrom")}
              variant="outlined"
              name="fechaRealizadaInicio"
              className="filtros altura"
              value={busqueda.fechaRealizadaInicio || ""}
              onChange={handleChange}
              onFocus={handleFocusRealizadaInicio}
              onBlur={handleBlurRealizadaInicio}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
            <TextField
              type={typeRealizadaFin}
              id="fechaRealizadaFin-input"
              label={t("filters.realizationDateTo")}
              variant="outlined"
              name="fechaRealizadaFin"
              className="filtros altura"
              value={busqueda.fechaRealizadaFin || ""}
              onChange={handleChange}
              onFocus={handleFocusRealizadaFin}
              onBlur={handleBlurRealizadaFin}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{ "aria-label": "controlled" }}
              InputLabelProps={esSafari() ? { shrink: true } : undefined}
            />
          </Box>
        </div>
        <div>
          <Button className="btn-buscador" onClick={clearAllFilters}>
            <ImCross />
          </Button>
        </div>
        <div>
          <Button className="btn-buscador" onClick={() => getBusqueda()}>
            <BsSearch />
          </Button>
        </div>
      </div>

      <style jsx="true">{`
        .btn-buscador {
          padding: 5px 10px;
          color: #ffffff;
          background-color: #92004d;
          border-radius: 4px;
          font-weight: bold;
          width: -moz-fit-content;
          width: fit-content;
          align-self: flex-end;
          border: none;
          min-width: 40px;
          height: 40px;
          margin: 5px 10px 5px;
        }
        .btn-buscador:hover {
          color: black;
          background-color: #dee2e6;
        }
      `}</style>
    </>
  );
};

export default withRouter(FiltrosInstalaciones);
